import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";
// import sign from "../../../assest/images/Singn.png";
 import sign from "../../../assest/LogoAndFavicon/Hrsign/keelhrsign.png";
//import sign from "../../../assest/LogoAndFavicon/Hrsign/xperthrsign.jpg";

export const Page9 = ({
  Earning,
  Deductions,
  Benefits,
  Salarydata,
  RowIDdata,
}) => {
  const headerStyle = {
    backgroundColor: "#d9d9d9",
    fontWeight: "bold",
  };

  let EarningData = Earning.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ).sort((a, b) => a?.componentName.localeCompare(b?.componentName));

  let Deductiondata = Deductions.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ).sort((a, b) => a?.componentName.localeCompare(b?.componentName));

  let Benefitsdata = Benefits.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ).sort((a, b) => a?.componentName.localeCompare(b?.componentName));

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const candidateName = capitalizeFirstLetter(RowIDdata?.candidateName);
  const totalRowStyle = {
    backgroundColor: "#d9d9d9",
  };

  function formatNameInitials(name) {
    if (!name) return "";

    const parts = name.trim().toLowerCase().split(" ");
    const Name = parts
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");



    return Name;
  }
  

  return (
    <ReusablePDFLayout>
      {/* <div className="parentcls" style={{ marginTop: "-50px" }}> */}
      <div
        className="parentcls"
        style={{
          width: "100%",
          height: "257mm", // A4 height minus header/footer space
          boxSizing: "border-box",
          // overflow: "hidden",
          padding: "10mm 15mm", // internal padding if needed
          // fontFamily: "Arial, sans-serif",
          fontSize: "10.5pt",
          lineHeight: "1.4",
          color: "#000",
          // backgroundColor: "#fff",
        }}
      >
        <p className="bol" style={{ textDecoration: "underline" }}>
          Annexure A
        </p>
        <div
          style={{
            display: "flex",
            margin: "15px 40px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "70%"  }}>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Name:</span>{" "}
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  // fontWeight: "800"
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {formatNameInitials(candidateName)}
              </span>
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  // fontWeight: "800"
                  // width: "calc(100% - 2rem)",
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {RowIDdata?.position}
              </span>
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Department :</span>{" "}
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  // fontWeight: "800"
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {RowIDdata?.department}
              </span>
            </p>
          </div>

          <div style={{ width: "30%"}}>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Location:</span>
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  // fontWeight: "800"
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                Chennai
              </span>
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Employee Code:</span>{" "}
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  // fontWeight: "800"
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {Salarydata?.empCode}
              </span>
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Grade:</span>{" "}
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  // borderBottom: "1px dotted gray",
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                A
              </span>
            </p>
          </div>
        </div>
        <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{
            margin: "24px 30px 0px 40px",
            width: "77%",
            marginTop: "20px",
          }}
        >
          <thead>
            {/* <tr style={headerStyle}>
              <td colSpan="3" style={{ textAlign: "left" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  
                  <td >CTC ALLOCATION</td>
                  <td style={{marginLeft:'10%'}}>{(Salarydata?.ctc / 12)?.toFixed(2)}</td>
                  <td>{Salarydata?.ctc}</td>
                </div>
              </td>
            </tr> */}
            <tr style={headerStyle}>
              <td style={{ paddingLeft: "7px" }}>CTC ALLOCATION</td>
              <td style={{ paddingLeft: "7px" }}>
                {(Salarydata?.ctc / 12)?.toFixed(2)}
              </td>
              <td style={{ paddingLeft: "7px" }}> {Salarydata?.ctc}</td>
            </tr>

            <tr style={headerStyle}>
              <td style={{ paddingLeft: "7px" }}>Salary Components</td>
              <td style={{ paddingLeft: "7px" }}>Monthly</td>
              <td style={{ paddingLeft: "7px" }}>Annually</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }} className="para">
                <b>Fixed (A)</b>
              </td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {EarningData[0]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[0]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[0]?.yearly}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {EarningData[1]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[1]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[1]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b style={{ marginLeft: "5px" }}>Total (A)</b>
              </td>
              <td>
                <b>{EarningData[0]?.monthly + EarningData[1]?.monthly}</b>{" "}
              </td>
              <td>
                <b>{EarningData[0]?.yearly + EarningData[1]?.yearly}</b>
              </td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Reimbursement Basket (B)</b>
              </td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {EarningData[2]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b style={{ marginLeft: "5px" }}>Total (B)</b>
              </td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>
                  {EarningData[3]?.componentName} (C)
                </b>
              </td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[3]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{EarningData[3]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b style={{ marginLeft: "5px" }}>Gross (D) = (A+B+C)</b>
              </td>
              {/* <td>{EarningData[0]?.monthly + EarningData[1]?.monthly + EarningData[2]?.monthly + EarningData[3]?.monthly } </td> */}
              <td>
                <b>{Salarydata?.gross}</b>{" "}
              </td>
              <td>
                <b>{(Salarydata?.gross * 12)?.toFixed(2)}</b>{" "}
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <b style={{ marginLeft: "5px" }}>Deductions</b>
              </td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {Deductiondata[1]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>
                {Deductiondata[1]?.monthly}
              </td>
              <td style={{ paddingLeft: "7px" }}>{Deductiondata[1]?.yearly}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {Deductiondata[0]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>
                {Deductiondata[0]?.monthly}
              </td>
              <td style={{ paddingLeft: "7px" }}>{Deductiondata[0]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b style={{ marginLeft: "5px" }}>Total Deductions</b>
              </td>
              {/* <td>{Deductiondata[1]?.monthly + Deductiondata[0]?.monthly}</td> */}
              <td>
                <b>{Salarydata?.totalDeductions}</b>
              </td>
              <td>
                <b>
                  {(
                    Deductiondata[1]?.yearly + Deductiondata[0]?.yearly
                  )?.toFixed(2)}
                </b>
              </td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Benefits</b>
              </td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {Benefitsdata[1]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[1]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[1]?.yearly}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {Benefitsdata[0]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[0]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[0]?.yearly}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "7px" }}>
                {Benefitsdata[2]?.componentName}
              </td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[2]?.monthly}</td>
              <td style={{ paddingLeft: "7px" }}>{Benefitsdata[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>Benefits Total (E)</b>
              </td>
              <td style={{ paddingLeft: "7px" }}>
                <b>{Salarydata?.totalBenefits}</b>
              </td>
              <td style={{ paddingLeft: "7px" }}>
                <b>{Salarydata?.totalBenefits * 12}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>Monthly & Annual CTC </b>
              </td>
              <td style={{ paddingLeft: "7px" }}>
                <b>{(Salarydata?.ctc / 12)?.toFixed(2)}</b>
              </td>

              <td style={{ paddingLeft: "7px" }}>
                <b>{Salarydata?.ctc}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b style={{ marginLeft: "5px" }}>Net Take Home </b>
              </td>
              <td style={{ paddingLeft: "7px" }}>
                <b>{Salarydata?.netPay}</b>
              </td>
              <td style={{ paddingLeft: "7px" }}>
                {" "}
                <b>{Salarydata?.netPay * 12}</b>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            width: "80%",
            justifyContent: "space-between",
          }}
        >
          <div style={{ marginLeft: "30px", marginTop: "4px" }}>
            <img src={sign} width={"180px"} style={{ marginLeft: "-19px" }} />
            <div style={{ marginTop: "-15px" }}>
              <p className="boldsoff">Name of the Signing Authority</p>
              <p className="boldsoff">People Partner</p>
            </div>
          </div>
          <div style={{ margin: "10px" }}>
            <p className="bolds">I accept the above offer</p>
            <div style={{ margin: "10px" }}>
              <p className="bolds">Signature:</p>
              <p className="bolds">Name:</p>
              <p className="bolds">Date:</p>
            </div>
          </div>
        </div>
      </div>
    </ReusablePDFLayout>
  );
};
